import { Component, Inject, OnDestroy, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, NavigationEnd } from '@angular/router';
import { take, filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-order-received-popup',
  templateUrl: './order-received-popup.component.html',
  styleUrls: ['./order-received-popup.component.scss']
})
export class OrderReceivedPopupComponent implements OnDestroy {

  sanitizedUrl: string = '';


  url = '';


  textAccount: string;
  data: any;
  title: any;
  message: any;
  // guard to prevent handling multiple submit clicks
  isSubmitting: boolean = false;

  constructor(
    public router: Router,
    private dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) data: any,
    @Optional() public dialogRef: MatDialogRef<OrderReceivedPopupComponent>,

  ) {
    this.data = data || null;
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  type: any;

  ngOnInit(): void {

    this.textAccount = 'OK';

    if (this.data && this.data.data) {
      this.title = this.data.data.Title;
      this.message = this.data.data.message;
      this.type = this.data.data.type;
    } else {
      this.title = '';
      this.message = '';
      this.type = null;
    }

  }

  submit() {
    // prevent multiple clicks from registering
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;

    if (this.dialogRef) {
      this.dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
        if (this.type != 5) {
          this.router.navigate(['/leadDetail/', this.data?.data?.leadId]);
        } else {
          this.router.navigate(['/companiesDetail/', this.data?.data?.leadId]);
        }
        // allow future submits again
        this.isSubmitting = false;
      });
      this.dialogRef.close();
    } else {
      // Not opened as a dialog — navigate immediately
      if (this.type != 5) {
        this.router.navigate(['/leadDetail/', this.data?.data?.leadId]);
      } else {
        this.router.navigate(['/companiesDetail/', this.data?.data?.leadId]);
      }
      this.isSubmitting = false;
    }

  }

  close() {
    this.dialog.closeAll();
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}

